import React from 'react'
import { Button, Container,
    Row, Col, Label, Input } from 'reactstrap'
import '../css/QuoteViewController.css'
import SimpleDropdown from '../view/DropDownView'
import TeamDropdown from '../view/TeamDropdown'
import DateTextField from '../view/DateTextField'
import { getBacklogs, updateBacklogsWithOrginal } from '../model/request/backlog'
import { getQuote, updateBacklogPage } from '../model/request/quotes'
import { getAsanteProjectManagers } from '../model/request/login'
import { Backlog } from '../model/Backlog'
import { Quote } from '../model/Quote'
import {
    InfoButton,
} from '../view/InfoButton'

const infoMessages = {
    '265feed1-d0ed-4be7-bf5c-49956e25dadc': 'Placed in "Daily Schedule" and "In Production" ' +
                                            'page after date specified',
    '3d936366-25cf-4077-8abe-340c5c1882c5': 'Placed in "Ready For Production" page after date specified',
    '9536b906-41a9-4b4a-81a8-be4faaa0f48b': 'Date appears in customer report.',
    '5ae4efb2-1c8f-46dd-815f-aec2e74a50c5': 'Specify is thermoformed here.',
}

class BacklogViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            'quote': null,
            'orginalQuotePage': null,
            'project_managers': [],
            'backlogs': [],
            'orginalBacklogs': [],
        }
    }

    quotePageFieldsChanged() {
        return JSON.stringify(this.state.orginalQuotePage) !== JSON.stringify(this.state.quote)
    }

    updateOrginalQuotePage(quote=null) {
        if (!quote) {
            quote = this.state.quote
        }

        this.setState({
            'orginalQuotePage': JSON.parse(JSON.stringify(quote)),
        })
    }

    updateOrigonalBacklogs(backlogs=null) {
        if (!backlogs) {
            backlogs = this.state.backlogs
        }

        const ogBacklogs = []
        for (let i = 0; i < backlogs.length; i++) {
            ogBacklogs.push(backlogs[i].copy())
        }
        this.setState({
            'orginalBacklogs': ogBacklogs,
        })
    }

    componentDidMount() {
        this.props.turnOnLoader(3)
        getBacklogs(this.props.id).then(
            (result) => {
                const backlogs = []
                for (let i = 0; i < result.data.backlogs.length; i++) {
                    backlogs.push(Backlog.from(result.data.backlogs[i]))
                }

                this.setState({
                    'backlogs': backlogs,
                })

                this.updateOrigonalBacklogs()
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        getQuote(this.props.id).then(
            (result) => {
                const quote = Quote.from(result.data.quote)
                this.setState({
                    'quote': quote
                })
                this.updateOrginalQuotePage(quote)
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )

        getAsanteProjectManagers().then(
            (result) => {
                this.setState({
                    'project_managers': result.data.project_managers,
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    // MARK: Use Loader

    turnOnLoader(by=1) {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader + by
            }
        })
    }

    turnOffLoader(by=1) {
        this.setState(function(state, props) {
            return {
                displayLoader: state.displayLoader - by
            }
        })
    }


    // MARK: Button Actions

    saveModel() {
        this.props.turnOnLoader(2)
        updateBacklogsWithOrginal(this.state.orginalBacklogs,
            this.state.backlogs, this.state.quote.id).then(
            (result) => {
                const backlogs = this.state.backlogs
                let bIndex = 0
                for (let i = 0; result.data.backlogs && i < result.data.backlogs.length; i++) {
                    while (backlogs[bIndex].type_id !== result.data.backlogs[i].type_id) {
                        bIndex += 1
                    }

                    backlogs[bIndex].id = result.data.backlogs[i].id
                }
                this.setState({
                    'backlogs': backlogs,
                })
                this.updateOrigonalBacklogs(backlogs)
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            },
        )

        if (this.quotePageFieldsChanged()) {
            updateBacklogPage(this.state.quote).then(
                (result) => {
                    this.updateOrginalQuotePage()
                    this.props.turnOffLoader()
                },
                (error) => {
                    this.props.showError(error)
                    this.props.turnOffLoader()
                },
            )
        } else {
            this.props.turnOffLoader()
        }
    }


    // MARK: View

    renderBacklog() {
        return this.state.backlogs.map((backlog, index) => {
            return <div>
                <Input
                    style={{
                        'marginTop': '23px',
                    }}
                    type="checkbox"
                    checked={backlog.is_checked}
                    onChange={(e) => {
                        const backlogs = this.state.backlogs
                        backlogs[index].is_checked = !backlogs[index].is_checked
                        this.setState({
                            'backlogs': backlogs,
                        })
                    }}/>
                <Label
                style={{
                    'marginLeft': '8px',
                    'marginTop': '16px',
                    'fontSize': '20px',
                    'fontWeight': '400',
                }}>{backlog.label} {
                    infoMessages[backlog.type_id] ?
                        <InfoButton
                            id={backlog.type_id}
                            message={
                                infoMessages[backlog.type_id]
                            } />
                        :
                        <></>
                }</Label>
                <div style={{
                    'marginLeft': '30px',
                    'maxWidth': '150px',
                    'position': backlog.is_checked ? '' : 'absolute',
                    'visibility': backlog.is_checked ? '' : 'hidden',
                }}>
                <DateTextField
                    value={backlog.date_given ? backlog.date_given : undefined}
                    showModal={this.props.showModal}
                    closeModal={this.props.closeModal}
                    onChange={(date) => {
                        const backlogs = this.state.backlogs
                        backlogs[index].date_given = date
                        this.setState({
                            'backlogs': backlogs,
                        })
                    }}/>
                 {
                     backlog.type_id === '5ae4efb2-1c8f-46dd-815f-aec2e74a50c5' ?
                     <>
                        <Label style={{
                            'fontWeight': '500',
                        }}>Is Thermoform</Label>
                        <Input
                            checked={this.state.quote ? this.state.quote.is_thermoformed : false}
                            type="checkbox" style={{
                                'marginLeft': '8px',
                            }}
                            onChange={(e) => {
                                const quote = this.state.quote
                                quote.is_thermoformed = !quote.is_thermoformed
                                this.setState({
                                    'quote': quote,
                                })
                            }}

                            />
                     </>
                     : 
                     backlog.type_id === 'd554771f-51ad-4e51-91c7-9ef60679e227' ?
                     <>
                        <Label style={{
                            'fontWeight': '500',
                        }}>Materials Ordered</Label>
                        <Input style={{
                                'marginLeft': '8px',
                            }}
                            value={this.state.quote ? this.state.quote.materials : ''}
                            onChange={(e) => {
                                const quote = this.state.quote
                                quote.materials = e.target.value
                                this.setState({
                                    'quote': quote,
                                })
                            }}

                            />
                     </>
                     :
                     <></>
                 }
                </div>
            </div>
        })
    }

    renderHeader(label) {
        return <Col>
            <Label style={{
                'fontSize': '20pt',
                'fontWeight': '500',
            }}>{label}</Label>
        </Col>
    }

    renderDropDown(value, values, onChange) {
        const updatedText = values.map((v) =>
            v == null ? "Empty" : v
        )
        if (values.indexOf(value) === -1) {
            updatedText.push(value)
        }
        updatedText.push('Other')
        return <SimpleDropdown
            index={updatedText.indexOf(value)}
            values={updatedText}
            onChange={(index) => {
                if (index === updatedText.length -1) {
                    this.props.showTextFieldModal('Project Manager', (value) => {
                        onChange(value, index)
                    })
                } else {
                    onChange(values[index], index)
                }
            }} />
    }

    render() {
        return (
            <Container>
                {this.props.breadCrumbs(1, this.props.id)}
                <Row>
                    { this.state.quote ?
                        <>
                        {this.renderHeader(this.state.quote.customer_name)}
                        {this.renderHeader(this.state.quote.job_name)}
                        {this.renderHeader(this.state.quote.given_id)}
                        </>
                        : <></>
                    }
                </Row>
                <Row>
                    <Col><Container>
                        <Row>
                            <Label style={{
                                'fontWeight': '450',
                                'fontSize': '16pt',
                            }}>PM</Label>
                        </Row>
                        {this.state.quote ? 
                            <SimpleDropdown
                                index={this.state.project_managers.findIndex(
                                    (x) => x.id === this.state.quote.project_manager
                                )}
                                values={this.state.project_managers.map(
                                    (x) => x.first_name + ' ' + x.last_name
                                )}
                                onChange={(index) => {
                                    const quote = this.state.quote
                                    quote.project_manager =
                                        this.state.project_managers[index].id
                                    this.setState({
                                        'quote': quote,
                                    })
                                }} />
                        : <></>}
                    </Container></Col>
                </Row>
                <Row>
                    <Col><Container>
                        <Row>
                            <Label style={{
                                'fontWeight': '450',
                                'fontSize': '16pt',
                            }}>Team</Label>
                        </Row>
                        {this.state.quote ?
                            <TeamDropdown
                                {...this.props}
                                quoteId={this.state.quote.id}
                                value={this.state.quote.team_name} />
                        : <></>}
                    </Container></Col>
                </Row>
                <Row>
                    <Col><Container>
                        <Row>
                            <Label style={{
                                'fontWeight': '450',
                                'fontSize': '16pt',
                            }}>Quote ID</Label>
                        </Row>
                        {this.state.quote ? 
                            <Label>{this.state.quote.quote_sequence}</Label>
                        : <></>}
                    </Container></Col>
                </Row>
                <Row>
                    <Col><Container>
                        <Row>
                            <Label style={{
                                'fontWeight': '450',
                                'fontSize': '16pt',
                            }}>Project Manager Comments</Label>
                        </Row>
                        {this.state.quote ? 
                            <Input
                                type='text'
                                value={this.state.quote.project_manager_comment}
                                onChange={(e) => {
                                    this.setState((state) => {
                                        state.quote.project_manager_comment = e.target.value
                                        return {
                                            'quote': state.quote,
                                        }
                                    })
                                }} />
                        : <></>}
                    </Container></Col>
                </Row>
                <Row>
                    <Col><Container>{this.renderBacklog()}</Container></Col>
                </Row>
                <Row
                    className='quote-bottom-bottons-row'>
                    <Col>
                        <Container>
                            <Button color="success" onClick={(e) => this.saveModel()}
                                size="lg" className="default-weight purchase-button"
                                >Save</Button>
                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default BacklogViewController
